import { authorize } from '../auth.js';

function initializeSocialLoginFlow(provider, returnPath) {
    const redirectUri = new URL('/my-account/callback', window.location.origin);
    redirectUri.searchParams.append('loginMethod', 'social');
    if (returnPath) {
        window.sessionStorage.setItem('login_returnPath', returnPath);
    }
    authorize({
        connection: 'google-oauth2',
        responseType: 'token id_token',
        redirectUri: redirectUri.toString()
    });
}

export { initializeSocialLoginFlow };
//# sourceMappingURL=initialize-social-login.js.map
